import { ICellRendererParams } from 'ag-grid-community';
import { ISourcingCompanyRow } from '../../../schemas/SourcingListItems.schema';
import { CompanyOverviewSection } from './CompanyOverviewSection';
import { FundingSection } from './FundingSection';
import { RecentNewsSection } from './RecentNewsSection';
import {
  panelContainerCss,
  panelContentCss,
  pinnedAccentBarCss,
  verticalDividerCss,
} from './sourcing-detail-panel.styles';

type SourcingDetailPanelProps = ICellRendererParams<ISourcingCompanyRow>;

export function SourcingDetailPanel(props: SourcingDetailPanelProps) {
  const data = props.data;
  if (!data) {
    return null;
  }

  // With pinned columns, ag-Grid renders the detail row in both the pinned
  // and center sections. Show only the accent bar in the pinned area.
  if (props.pinned) {
    return <div css={pinnedAccentBarCss} />;
  }

  return (
    <div css={panelContainerCss}>
      <div css={panelContentCss}>
        <CompanyOverviewSection data={data} />
        <div css={verticalDividerCss} />
        <FundingSection data={data} />
        <div css={verticalDividerCss} />
        <RecentNewsSection news={data.recentNews ?? []} />
      </div>
    </div>
  );
}
